import React, { useCallback, useEffect, useState } from 'react';
import { memoNamed } from '../utils/react/memo-named';
import { StringInput } from './common/input';
import styled from 'styled-components';

interface Props {
  tagKey: string;
  tagName: any;
  value: string;
  onValueChange: (value: string) => void;
}

const AddMemberInfo = styled.div`
  width: 100%;
  margin: 0 auto;
  font-size: 11px;
`;

const AddMemberInfo1 = styled.div`
  text-align: left;
`;

const AddMemberInfo2 = styled.div`
  color: red;
  text-align: left;
`;

const AddMemberInfoInput = styled(StringInput)`
  width: 100%;
  outline: none;
  border: none;
  font-size: 15px;
  &:focus {
    outline: none;
  }
`;

export const AdminAddMemberInfo = memoNamed<Props>(
  'AdminAddMemberInfo',
  (props: Props) => {
    const [message, setMessage] = useState<string>('');

    useEffect(() => {
      // TODO: this useEffect is dummy to suppress "no-unused-vars" warnings for these variables and must be removed later.
      setMessage('');
    }, []);

    const checkinfo = useCallback(() => {
      // かなだけか、数値のみか
      if (props.tagKey === 'sei') {
        // TODO
      } else if (props.tagKey === 'mei') {
        // TODO
      } else if (props.tagKey === 'sei_kana') {
        // TODO
      } else if (props.tagKey === 'mei_kana') {
        // TODO
      } else if (props.tagKey === 'enter_year') {
        // TODO
      }
    }, [props.tagKey]);

    return (
      <AddMemberInfo>
        <AddMemberInfo1>{props.tagName}</AddMemberInfo1>
        <AddMemberInfo2>{message}</AddMemberInfo2>
        <AddMemberInfoInput
          id={props.tagKey}
          className='Add_member_Info_input'
          type='text'
          onBlur={checkinfo}
          value={props.value}
          onValueChange={props.onValueChange}
        />
      </AddMemberInfo>
    );
  }
);
